import React from 'react';
import { ObjectTabsProps } from "../../../../types/ObjectBrowser/ComponentTypes";

const ObjectTabs: React.FC<ObjectTabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <ul id="menu-inner" className="col nav nav-tabs menu-top" role="tablist">
            {tabs.map((tab) => (
                <li key={tab.id} className="nav-item" role={tab.value}>
                    <button
                        type="button"
                        id={tab.id}
                        data-bs-toggle="tab"
                        onClick={() => onTabChange(tab.value)}
                        className={activeTab === tab.value ? 'active' : ''}
                        role="tab"
                        aria-controls={tab.value}
                        aria-selected={activeTab === tab.value}
                    >
                        {tab.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default ObjectTabs; 